// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__6d9u2","addWidgetButton":"Header_addWidgetButton__22If1","dashboardTabs":"Header_dashboardTabs__2HUcQ","active":"Header_active__naJIP"};